import * as React from 'react';
import useGeneralHook from '../../../../common/hook/useGeneralHook';
import { HookPaginationProps } from '../../../../common/hook/usePaginationHook';
import SchemaForm from '../../../../common/SchemaForm';
import { setOrderTherapy } from '../../../../common/redux/commonReducer';
import { schemaFilterTherapyForm } from './schema';
import { useUserRoles } from 'modules/common/hook';
import { ROLES } from 'modules/common/constants';

interface Props {
  pagin?: React.ReactNode;
  onRegister?: () => void;
  hookPagination: HookPaginationProps;
  onDataLoading: boolean;
}

const FilterTherapyBox: React.FunctionComponent<Props> = (props) => {
  const { hookPagination, pagin, onDataLoading, onRegister } = props;
  const { params, setParams, clearParams } = hookPagination;
  const { dispatch } = useGeneralHook();

  const pics = useUserRoles(
    ROLES.DOCTOR.value,
    ROLES.GENERAL_DOCTOR.value,
    ROLES.NURSE.value,
    ROLES.RADIOLOGIST.value,
    ROLES.LABORATORY_TECHNOLOGIST.value,
    ROLES.RADIOGRAPHER.value,
    ROLES.CLINICAL_PATHOLOGIST.value,
  );

  const picOptions = React.useMemo(
    () => pics.map((pic) => ({ value: pic.id, label: pic.employeeFullName })) || [],
    [pics],
  );

  return (
    <SchemaForm
      schema={schemaFilterTherapyForm}
      onSubmit={(value) => {
        dispatch(setOrderTherapy(value.orderBy));
        setParams(value);
      }}
      formData={params}
      clearParams={clearParams}
      hideSubmitButton
      pagin={pagin}
      onRegister={onRegister}
      onDataLoading={onDataLoading}
      picOptions={picOptions}
    />
  );
};

export default FilterTherapyBox;
